import React, { Fragment } from 'react';
import { Interpolate, Link } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';

import styles from './DistributionDialog.scss';

type PropsType = {
  distributionList: Array<number>;
  members: Array<any>;
  toggleShowUsers: () => void;
  truncate: boolean;
};

const UserNames: React.FC<PropsType> = ({ distributionList, members, truncate, toggleShowUsers }) => {
  if (distributionList.length === 1) {
    const name = members
      .filter((m) => {
        return distributionList.indexOf(m.id) !== -1;
      })
      .map((m) => m.name)
      .join('');

    return <Interpolate str={t('Начислить ресурсы игроку: %(name)s')} name={name} parentTag={'p'} />;
  } else {
    const names = members
      .filter((m) => {
        return distributionList.indexOf(m.id) !== -1;
      })
      .map((m) => m.name)
      .join(', ');

    return (
      <Interpolate
        str={t('%(title)s %(names)s %(more)s')}
        title={<span className={styles.betweenTitle}>{t('Распределить ресурсы между игроками:')}</span>}
        names={names}
        more={
          truncate ? null : (
            <Fragment>
              &nbsp;
              <Link isActionLink={false} arrow={''} onClick={toggleShowUsers}>
                {t('скрыть')}
              </Link>
            </Fragment>
          )
        }
        parentTag={'p'}
      />
    );
  }
};

export default UserNames;
